import {Dropdown, Table} from "react-bootstrap";
import * as React from "react";
import {Suspense} from "react";
import {usePricingQuery} from "../../../hooks/usePricingQuery";
import {PriceModel} from "../../../models/domain/priceModel";
import Skeleton from "react-loading-skeleton";
import {FaInfoCircle} from "react-icons/fa";

export const PricingTable = () => {
    return (
        <Suspense fallback={<Skeleton count={1}/>}>
            <Content/>
        </Suspense>
    )
}

const Content = () => {
    const {model: {breakOutEarly, prices}, currencyCode, error} = usePricingQuery();

    if (breakOutEarly || error) return <></>;

    return (
        <Dropdown id="pricingTableDropdown">
            <Dropdown.Toggle variant="link" className="p-0" aria-label="See Quantity Pricing Discounts! Pricing For Different Quantities DropDown">
                <FaInfoCircle className="me-1" aria-hidden="true"/>
                See Quantity Pricing Discounts!
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.ItemText>
                    <Table striped bordered className="pricing-table">
                        <thead>
                        <tr>
                            <th className="border-end-0">Quantity</th>
                            <th className="border-start-0">Price Each ({currencyCode})</th>
                        </tr>
                        </thead>
                        <tbody>
                        {prices.map((price, index) => <PriceRow key={index} model={price}/>)}
                        </tbody>
                    </Table>
                </Dropdown.ItemText>
            </Dropdown.Menu>
        </Dropdown>
    )
}

const PriceRow = ({
                      model: {
                          lowRange, highRange, onSale,
                          formatted: {
                              currentPrice,
                              unitPrice
                          }
                      }
                  }: { model: PriceModel }) => {
    return (
        <tr>
            <td className="border-end-0">
                <span>{lowRange}</span> - <span>{highRange}</span>
            </td>
            <td className="d-flex align-items-center border-start-0">
                {onSale &&
                    <div className="me-2" style={{fontSize: '0.8rem'}}>
                    <span className="text-muted" style={{textDecoration: 'line-through'}}>
                        {unitPrice}
                    </span>
                    </div>
                }
                <div className="normal-price">{currentPrice}</div>
            </td>
        </tr>
    )
}